import { Text, Box, IconCritical } from 'braid-design-system';
import { observer } from 'mobx-react';

import Loader from '../../common/Loader';

interface Props {
  errorMessage?: string;
  loading?: boolean;
}

const AddAttachmentMessages = ({ errorMessage, loading = false }: Props) => (
  <Box>
    {loading && (
      <Box data-testid="loader">
        <Loader />
      </Box>
    )}
    {errorMessage && (
      <Box marginTop="small">
        <Text
          tone="critical"
          size="small"
          icon={<IconCritical tone="critical" />}
        >
          {errorMessage}
        </Text>
      </Box>
    )}
  </Box>
);

export default observer(AddAttachmentMessages);
